import script from "./LotterySection.vue?vue&type=script&setup=true&lang=ts"
export * from "./LotterySection.vue?vue&type=script&setup=true&lang=ts"

import "./LotterySection.vue?vue&type=style&index=0&id=7fb42590&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fb42590"]])

export default __exports__